/**
 * AUCR-753 — Modelos da tela de upgrade de doação.
 * Apenas tipagem documental (Vue 2.6 + JS puro); o backend já garante a forma da resposta.
 */

export class UpgradeOption {
    constructor(data = {}) {
        this.incrementPercentage = data.incrementPercentage || 0;
        this.incrementValue = data.incrementValue || 0;
        this.newTotalValue = data.newTotalValue || 0;
        this.isRecommended = !!data.isRecommended;
    }
}

export class UpgradeBranding {
    constructor(data = {}) {
        this.themePrimaria = data.themePrimaria || null;
        this.themeSecundaria = data.themeSecundaria || null;
        this.themeDestaque = data.themeDestaque || null;
        this.themeFundo = data.themeFundo || null;
        this.themePadrao = data.themePadrao || null;
        this.themeGradienteStart = data.themeGradienteStart || null;
        this.themeGradienteEnd = data.themeGradienteEnd || null;
        this.themeTexto = data.themeTexto || null;
        this.fontPrincipal = data.fontPrincipal || null;
        this.fontDestaques = data.fontDestaques || null;
        this.logoUrl = data.logoUrl || null;
        this.heroImageUrl = data.heroImageUrl || null;
        this.cssInjection = data.cssInjection || null;
    }
}

export class UpgradeDonation {
    constructor(data = {}) {
        this.checkoutCode = data.checkoutCode || null;
        this.donorName = data.donorName || "";
        this.donorEmail = data.donorEmail || "";
        this.donorDocument = data.donorDocument || "";
        this.campaignName = data.campaignName || "";
        this.recurrencePeriod = data.recurrencePeriod || "";
        this.currentValue = data.currentValue || 0;
        this.options = (data.options || []).map((o) => new UpgradeOption(o));
        // "url" = opções vindas do parâmetro u do link da captação; "default" = 20/30/50.
        this.optionsSource = data.optionsSource || "default";
        // Texto de introdução da campanha de captação (vem do u). Renderizar como texto, nunca v-html.
        this.context = data.context || "";
        this.branding = new UpgradeBranding(data.branding || {});
    }
}

/**
 * Converte uma cor armazenada no AUC como string "[R, G, B, A]" em valor CSS válido `rgba(R,G,B,A)`.
 * Mesmo formato usado por CampaignLandingPageConfigBusiness.BuildCssSkin no back-end.
 * @param {string} colorStr
 * @returns {string|null}
 */
export function parseAucColor(colorStr) {
    if (!colorStr) return null;
    const cleaned = String(colorStr).replace(/[[\]\s]/g, "").trim();
    if (!cleaned) return null;
    return `rgba(${cleaned})`;
}
